export enum SupplierInvoiceGridColumns {
  InvoiceNumber = 'Invoice.InvoiceNumber',
  InvoiceDate = 'Invoice.InvoiceDate',
  DueDate = 'Invoice.DueDate',
  PaymentMethod = 'Invoice.PaymentMethod',
  Status = 'Invoice.Status',
  Type = 'Invoice.Type',
  Currency = 'Invoice.Currency',
  TotalAmount = 'Invoice.TotalAmount',
  TotalVatAmount = 'Invoice.TotalVatAmount',
  TotalAmountInclVat = 'Invoice.TotalAmountInclVat'
}

export interface SupplierAllInvoiceRow {
  Invoice: SupplierAllInvoice
}

export interface SupplierAllInvoice {
  InvoiceNumber: string
  InvoiceDate: string
  DueDate: string
  PaymentMethod: string
  Status: string
  Type: string
  Currency: string
  TotalAmount: number
  TotalVatAmount: number
  TotalAmountInclVat: number
}
